import { Protocol } from '../Protocol';

export class StorageProtocol {
  public static readonly ALL_STORAGES: string = `${Protocol.YATUNG_API_ROOT}/storage/all`; // 取得所有料庫
}
